
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForceCurrentRelative as ObiForceCurrentRelativeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-force-current-relative.js';
 
 
 

 
 export const ObiForceCurrentRelative = createComponent({
   react: React,
   tagName: 'obi-force-current-relative',
   elementClass: ObiForceCurrentRelativeElement,
   events: {
     
   }
  });
 
 